const gray = "#616161";
const orange = "#ff9a3c";
const yellow = "#ffea3c";
const lightBlue = "#66a6ff";
const darkBlue = "#161467";
const green = "#3dbd58";
const red = "#e83b3b";

export { gray, orange, yellow, lightBlue, darkBlue, green, red };
